import React, { useEffect, useState } from 'react'
import { Dialog, DialogTitle, DialogContent, Stack, Box } from '@mui/material'
import CreateDutyForm from './CreateDutyForm'

const CreateDutyModal = ({ open, onClose, editDuty, selectedDate }) => {
  // The repeat panel lays its options and summary side by side, so the
  // dialog widens while it's open
  const [repeating, setRepeating] = useState(false)

  useEffect(() => {
    if (!open) setRepeating(false)
  }, [open])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={repeating ? 'lg' : 'sm'}
    >
      <DialogTitle>
        <Stack
          direction="row"
          gap={1}
          justifyContent="space-between"
          alignItems="center"
        >
          <>
            {editDuty
              ? 'Edit PTS Duty'
              : repeating
                ? 'Create Repeating PTS Duties'
                : 'Create New PTS Duty'}
          </>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Box paddingY={2}>
          <CreateDutyForm
            editDuty={editDuty}
            selectedDate={selectedDate}
            onClose={onClose}
            onRepeatChange={setRepeating}
          />
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default CreateDutyModal
